import { isGA, siteName } from 'lib/src/constants/environment';
import { Config } from '.';

export const IX_API_URL = 'http://ixstaging-env.eba-sucrgp3a.eu-west-1.elasticbeanstalk.com';
export const GA_API_URL = 'http://ixgastaging-env.eba-ppcmar4q.eu-west-1.elasticbeanstalk.com';
export const IX_WEB_URL = 'http://ixstagingwebenv.eba-cfjikn8e.eu-west-1.elasticbeanstalk.com';
export const GA_WEB_URL =
    'http://ix-ga-staging-web-env-env.eba-cfjikn8e.eu-west-1.elasticbeanstalk.com';

const config: Config = {
    API_URL: isGA ? GA_API_URL : IX_API_URL,
    S3_URL: 'https://s3-eu-west-1.amazonaws.com/ktn-media',
    SITE: siteName,
    WEB_URL: isGA ? GA_WEB_URL : IX_WEB_URL,
    IX_WEB_URL,
    GA_WEB_URL,
};

export default config;
